import TimeRangePicker from './time-range-picker';
import DateRangePicker from './date-range-picker';

const Forms = {
  TimeRangePicker, DateRangePicker,
};

export default Forms;
